import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { withSnackbar } from 'notistack';
import { setAlertActionCreator } from 'plugins/store/reducers/common.reducer';

import { getRecipientList, uploadRecipientList } from 'services/billig-report.service';
import withStyles from '@material-ui/core/styles/withStyles';

// components
import SnackMessage from 'components/Snackbar/SnackMessage';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import CsvUpload from 'components/CustomUpload/CsvUpload';
import ValidationDialog from './ValidationDialog';

import styles from 'assets/jss/material-dashboard-pro-react/views/billingReportStyles';

class BillingReportRecipients extends Component {

	state = {
		isLoading: false,
		recipientList: [],
	};

	componentDidMount() {
		this.getRecipientList();
	}

	showToastMessage = (message, color = 'danger') => {
		this.props.enqueueSnackbar(message, {
			content: (key, message) => <SnackMessage id={key} message={message} color={color} />,
		});
	}

	getRecipientList = async () => {
		this.setState({ isLoading: true });
		try {
			const recipientList = await getRecipientList();
			this.setState({ recipientList })
		} catch (error) {
			this.showToastMessage(error.resolvedErrorMessage);
		}
		this.setState({ isLoading: false });
	}

	onCsvLoad = async (file) => {
		this.setState({ isLoading: true });
		try {
			const result = await uploadRecipientList(file);
			const {
				totalEmailsCount,
				addedEmailsCount,
			} = result;
			if (totalEmailsCount !== addedEmailsCount) {
				this.openValidationDialog(result);
			} else {
				this.showToastMessage('BilLing Report Recipient List has been updated successfully!', 'success');
			}
			this.getRecipientList();
		} catch (error) {
			this.showToastMessage(error.resolvedErrorMessage);
		}
		this.setState({ isLoading: false });
	}
	openValidationDialog = (props) => {
		this.props.setAlert({
			type: 'scrollable',
			maxWidth: 'xs',
			children: <ValidationDialog {...props} />,
			onConfirm: () => this.props.setAlert(null),
		});
	}

	render() {
		const { classes } = this.props;
		const loadingIndicator = this.state.isLoading
			? <div className={classes.loadingIndicatorWrapper}><LoadingIndicator /></div>
			: null;
		const noResultsFoundText = (!this.state.isLoading && this.state.recipientList.length === 0)
			? <div className={classes.noResultsFound}>No Results Found</div>
			: null;

		return (
			<div className={classes.wrapper}>
				<div>
					<CsvUpload
						onLoad={this.onCsvLoad}
						label="Upload List of Recipients"
						dialogTitle="Upload List of Recipients"
					/>
				</div>
				{loadingIndicator}
				<div className="ReactTable -striped -highlight">
					<table className="rt-table">
						<thead className="rt-thead -header">
							<tr className={classnames('rt-tr', classes.tr)}>
								<th className={classnames('rt-th rt-resizable-header', classes.th)}>
									E-mail
											</th>
							</tr>
						</thead>
						<tbody className="rt-tbody">
							{this.state.recipientList.map(
								(
									email,
									index
								) => (
									<tr
										key={index}
										className={classnames(
											'rt-tr',
											classes.tr,
											{ ' -odd': index % 2 === 0 },
											{ ' -even': index % 2 === 1 }
										)}
									>
										<td className={classnames('rt-td', classes.td)}>
											{email}
										</td>
									</tr>
								)
							)}
						</tbody>
					</table>
				</div>
				{noResultsFoundText}
			</div>
		);
	}
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	setAlert: bindActionCreators(
		setAlertActionCreator,
		dispatch,
	),
});

export default compose(
	withStyles(styles),
	withSnackbar,
	connect(mapStateToProps, mapDispatchToProps),
)(BillingReportRecipients);
